seedWebApp.controller('ContactDrawingsController', ['$scope', '$rootScope', 'ContactService', '$uibModal', 'ToastService', 'TranslationService', 'StoreService', function ($scope, $rootScope, ContactService, $uibModal, ToastService, TranslationService, StoreService) {

    console.log('ContactDrawingsController');

    $scope.translation = TranslationService.getActiveTranslation();
    $scope.prefs = {
        name: 'RoutesGrid',
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,
    };

    $scope.contactClass = function (item) {
        if (item == 'ALL') {
            return 'qt-pos';
        }
        else {
            return 'qt-stocks';
        }
    };

    $scope.columns = [
        { name: 'ContactID', display: 'Cliente', orderBy: 'asc', editable: false, width: 10, isKey: true, customClass: $scope.contactClass },  //filterOptions: [] 
        { name: 'DrawingID', display: 'Desenho', editable: false, width: 25 },
        { name: 'DrawingModel', display: 'Modelo', editable: true, width: 15 },
        { name: 'EspessuraPedidoNome', display: 'Espessura Pedido', editable: true, width: 15 },
        { name: 'LarguraPedidoNome', display: 'Largura Pedido', editable: true, width: 15 },
        { name: 'EspessuraAmostraNome', display: 'Espessura Amostra', editable: true, width: 15 },
        { name: 'LarguraAmostraNome', display: 'Largura Amostra', editable: true, width: 15 },
    ];


    $scope.prefs.sortByCol = $scope.columns[0];
    $scope.prefs.sortByCol.orderReverse = false;

    $scope.loadService = ContactService.getContactDrawings;
    $scope.resetService = ContactService.resetCache;
    //$scope.loadColumns = ContactService.getContactsColumns;

    $scope.getTotal = function () {
        $scope.loadingTotal = true;
        ContactService.getContactDrawingsCount().then(function (response) {
            $scope.loadingTotal = false;
            if (response) {
                $scope.totalItems = response.data.TotalCount;
                $scope.lastSync = response.data.LastSync;
            }

        });
    };

    $scope.getTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'Clientes');
    };

    $scope.doInsert = function () {
        $scope.$broadcast('addItem');
    };

    //$(document).ready(function () {
    //    $scope.overflowSize = $scope.AdjustSize();
    //});

}]);
